export { parseQueryStrings as default } from '@crehana/utils';
export type { ObjectQueryParams } from '@crehana/utils';
